import React from 'react'
import styled from 'styled-components'
import { Dialog, DialogContent, IconButton } from '@material-ui/core'
import { Cancel } from '@material-ui/icons'

export default function SimpleModal(props: {
  open: boolean
  onCloseButtonClick: () => void
  enableClosingOnOutsideClick?: boolean
  children: React.ReactNode
  width?: string
  height?: string
  margin?: string
  padding?: string
  closeButtonPadding?: string
  showCloseButton?: boolean
}) {
  const {
    open,
    onCloseButtonClick,
    enableClosingOnOutsideClick = true,
    children,
    width,
    height,
    margin,
    padding,
    closeButtonPadding,
    showCloseButton = true,
  } = props

  return (
    <SimpleDialog
      open={open}
      onClick={enableClosingOnOutsideClick ? onCloseButtonClick : undefined}
      width={width}
      height={height}
      margin={margin}
      padding={padding}
      closeButtonPadding={closeButtonPadding}
    >
      {showCloseButton && (
        <IconButton className="close-button" onClick={onCloseButtonClick}>
          <Cancel />
        </IconButton>
      )}
      <DialogContent>{children}</DialogContent>
    </SimpleDialog>
  )
}

const SimpleDialog = styled(Dialog)<{ width?: string; height?: string; margin?: string; padding?: string; closeButtonPadding?: string; }>`
  text-align: center;
  line-height: 28px;
  .MuiDialog-paper {
    width: ${({ width }) => width || 'inherit'};
    max-width: ${({ width }) => width || 'inherit'};
    min-height: ${({ height }) => height || 'inherit'};
    margin: ${({ margin }) => margin || 'inherit'};
    padding: ${({ padding }) => padding || 'inherit'};
    @media (max-width: 640px) {
      width: 90vw;
      max-width: inherit;
      min-height: inherit;
    }
  }
  .close-button {
    position: absolute;
    right: 0;
  }
  .MuiIconButton-root {
    padding: ${({ closeButtonPadding }) => closeButtonPadding || '12px'}; 
  }
`
